module.exports = __webpack_public_path__ + "img/bg_home.b950ae44.jpg";